import { FormattedMessage } from 'react-intl';
import css from './HowItWorks.module.css';

const steps = [
  {
    id: 1,
    iconId: 'step1',
    icon: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-search-check w-8 h-8 text-green-600" aria-hidden="true"><path d="m8 11 2 2 4-4"></path><circle cx="11" cy="11" r="8"></circle><path d="m21 21-4.3-4.3"></path></svg>,
    titleId: 'LandingPage.HowItWorks.step1Title',
    descId: 'LandingPage.HowItWorks.step1Desc',
  },
  {
    id: 2,
    iconId: 'step2',
    icon: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-file-check w-8 h-8 text-green-600" aria-hidden="true"><path d="M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z"></path><path d="M14 2v5a1 1 0 0 0 1 1h5"></path><path d="m9 15 2 2 4-4"></path></svg>,
    titleId: 'LandingPage.HowItWorks.step2Title',
    descId: 'LandingPage.HowItWorks.step2Desc',
  },
  {
    id: 3,
    iconId: 'step3',
    icon: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-message-square w-8 h-8 text-green-600" aria-hidden="true"><path d="M22 17a2 2 0 0 1-2 2H6.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 2 21.286V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2z"></path></svg>,
    titleId: 'LandingPage.HowItWorks.step3Title',
    descId: 'LandingPage.HowItWorks.step3Desc',
  },
  {
    id: 4,
    iconId: 'step4',
    icon: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-circle-check w-8 h-8 text-green-600" aria-hidden="true"><circle cx="12" cy="12" r="10"></circle><path d="m9 12 2 2 4-4"></path></svg>,
    titleId: 'LandingPage.HowItWorks.step4Title',
    descId: 'LandingPage.HowItWorks.step4Desc',
  },
];

const HowItWorks = () => {
  return (
    <section className={css.howItWorksSection}>
      <div className={css.howItWorksContainer}>
        <div className={css.sectionHeader}>
          <h3 className={css.sectionTitle}>
            <FormattedMessage id="LandingPage.HowItWorks.title" />
          </h3>
          <p className={css.sectionDescription}>
            <FormattedMessage id="LandingPage.HowItWorks.description" />
          </p>
        </div>
        <div className={css.stepsGrid}>
          {steps.map(step => (
            <div key={step.id} className={css.stepCard}>
              <div className={css.stepIcon}>
                <span className={css.iconEmoji}>{step.icon}</span>
              </div>
              <h4 className={css.stepTitle}>
                <FormattedMessage id={step.titleId} />
              </h4>
              <p className={css.stepDescription}>
                <FormattedMessage id={step.descId} />
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
